import { render } from "./ComboFormaEntrega.vue?vue&type=template&id=5cbe1a9a&ts=true"
import script from "./ComboFormaEntrega.vue?vue&type=script&lang=ts"
export * from "./ComboFormaEntrega.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__